import { render, staticRenderFns } from "./mobileRemote.vue?vue&type=template&id=1e8efcde&scoped=true"
import script from "./mobileRemote.vue?vue&type=script&lang=js"
export * from "./mobileRemote.vue?vue&type=script&lang=js"
import style0 from "./mobileRemote.vue?vue&type=style&index=0&id=1e8efcde&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8efcde",
  null
  
)

export default component.exports